export enum AlertStatusEnum {
  PENDING = 'PENDING',
  DELIVERED = 'DELIVERED',
  FAILED = 'FAILED',
  PARTIAL_DELIVERED = 'PARTIAL_DELIVERED',
}
